import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
//
import Login from './pages/Login';
import DashboardApp from './pages/DashboardApp';
import NotFound from './pages/Page404';
import CreateAgreement from './pages/agreements/CreateAgreement';
import AddCarDetails from './pages/cardetails/AddCarDetails';
import AccountList from './pages/accounts/AccountList';
import ProformaInvoicesList from './pages/proformainvoices/ProformaInvoicesList';
import FinalInvoicesList from './pages/finalinvoices/FinalInvoicesList';
import AgreementList from './pages/agreements/AgreementList';
import ReProcessingList from './pages/reprocessing/ReProcessingList';
import InstallmentList from './pages/installments/InstallmentList';


// ----------------------------------------------------------------------

export default function Router() {
  const isLoggedIn  = sessionStorage.getItem("isSignedIn");
  let element = useRoutes([
    {
      path: '/dashboard',
      element: isLoggedIn ? <DashboardLayout /> : <Navigate to="/login" />,
      children: [
        // { element: <Navigate to="/dashboard/app" /> },
        { path: 'app', element: <DashboardApp /> },
        { path: 'create/agreement', element: <CreateAgreement /> },
        { path: 'add/car', element: <AddCarDetails /> },
        { path: 'accounts', element: <AccountList /> },
        { path: 'proforma/invoices', element: <ProformaInvoicesList /> },
        { path: 'final/invoices', element: <FinalInvoicesList /> },
        { path: 'agreements', element: <AgreementList /> },
        { path: 'reprocessings', element: <ReProcessingList /> },
        { path: 'installments', element: <InstallmentList/> },
      ]
    },
    { path: '/',  element: <Navigate to="/login" replace /> },
    { path: '/login',  element: isLoggedIn ? <Navigate to="/dashboard/app" /> : <Login /> },
    { path: '404',  element: <NotFound />},
    { path: '*', element: <Navigate to="/404" replace /> }
  ]);
  return element;
}
